import { useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
import { useSLUGName } from '../../hooks/useHistory';
import { usersApi, UserResponse } from '../../api/users';

const ORG_ADMINS = 'ORG_ADMINS';

export const useQueryOrgAdmins = () => {
  const organization = useSLUGName();

  const processor = useCallback(async () => {
    if (!organization) return [];

    const response = await usersApi.admins();

    return response.data.nodes;
  }, [organization]);

  const {
    data,
    isLoading: loading,
    refetch,
  } = useQuery([ORG_ADMINS, organization], processor, {
    enabled: !!organization,
  });

  return {
    admins: data ?? [],
    loading,
    refetch,
  };
};
